import { useMutation, useQueryClient } from '@tanstack/react-query';
import useForm from '../../../../lib/hooks/useForm';
import { updateTilesDigestAutomator } from './data';
import { BIWEEKLY, NINE_AM, WEDNESDAY } from './Constants';

const useAutomateForm = ({ automator, scheduledMessage }) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(updateTilesDigestAutomator, {
    onSuccess: ({ data }) => {
      queryClient.setQueryData(['updateAutomator'], data);
    },
  });

  const initialValues = {
    frequencyCd:
      automator.frequencyCd !== null ? automator.frequencyCd : BIWEEKLY,
    day: automator.day || WEDNESDAY,
    time: automator.time || NINE_AM,
    activeUsers: !automator.includeUnclaimedUsers || false,
    includeSms: automator.includeSms || false,
    hasFollowUp: automator.hasFollowUp || false,
    persisted: automator.persisted,
    id: automator.id,
    scheduledMessage,
    demoId: automator.demoId,
  };

  const onSubmit = values => {
    mutate({
      tilesDigestAutomator: values,
      tilesDigestAutomatorId: automator.id,
    });
  };

  const form = useForm({
    onSubmit,
    initialValues,
    enableReinitialize: true,
  });
  return form;
};

export default useAutomateForm;
